import styled from 'styled-components';
import { Modal, Form, FormGroup } from 'rsuite';

export const StyledModal = styled(Modal)`
  width: 414px;
`;

export const FormHeader = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-right: 8;
  margin-bottom: 8;
  position: relative;
  > div {
    top: 0;
  }
`;

export const StyledForm = styled(Form)`
  > .rs-form-group:nth-child(2) {
    .rs-control-label {
      text-align: left;
      padding-top: 12px;
      padding-bottom: 6px;
    }
    .rs-input-group {
      width: 70px;
    }
  }
  .rs-form-group .rs-control-label,
  .rs-radio label {
    font-size: 12px;
    font-weight: normal;
    text-transform: uppercase;
  }
  .rs-radio-group {
    > .rs-input-group {
      float: right;
      width: 70px;
    }
    .rs-radio {
      margin-left: 0;
    }
    .or {
      height: 14px;
      margin-top: -8px;
      margin-left: 36px;
    }
  }
  .rs-input.error,
  .rs-input-number.error {
    border-color: #f44336 !important;
  }
`;

export const StyledFormGroup = styled(FormGroup)`
  min-height: 36px;
  margin-left: 10px;
  margin-bottom: 5px !important;
  .rs-form-control-wrapper {
    float: right !important;
  }
`;

export const BreakdownSection = styled.div`
  position: relative;
  &.disabled :first-child,
  &.disabled .rs-control-label {
    color: #c5c6c7;
  }
  .rs-form-group {
    .rs-control-label {
      text-transform: none;
      margin-right: 10px;
      &:first-of-type {
        width: 120px;
      }
      &:last-of-type {
        width: 114px;
        margin-left: 10px;
        margin-bottom: 10px;
        text-align: left;
      }
    }
    .rs-input {
      width: 40px;
    }
    .rs-input-group {
      width: 70px;
      float: right;
    }
  }

  :not(.rs-form-inline) .rs-form-group:not(:last-child) {
    margin-bottom: 0;
  }
`;

export const QtyHeader = styled.div`
  top: -20px;
  right: 0;
  font-size: 12px;
  font-weight: normal;
  margin-right: 10px;
  margin-bottom: 8px;
  position: absolute;
`;
